import http from "@/settings/apiSettings"

class CerinteService {
    save(data: any) : Promise<any> {
        return http.clientResurseUmaneOdata.post("/RU_StructuriCerinte", data)
    }
}
export default new CerinteService()